import {Component, Input, OnInit} from '@angular/core';
import {FontAwesomeService} from "@services/font-awesome.service";
import {Store} from "@ngrx/store";
import {FOOTER_ACTION_SET} from "@store/actions";
import {Subject} from "rxjs/Subject";
import {takeUntil} from "rxjs/operators";
import {selectRouterUrl, selectShipmentProductTerms} from "@store/reducers";
import {TranslateService} from "@ngx-translate/core";
import {FooterActionEnum} from "@models/footer-action.enum";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public footerActions: typeof FooterActionEnum = FooterActionEnum;
  carriers: Array<{sv: string; title: string}>;
  title: string;
  buttons: {action: FooterActionEnum, type?: FooterActionEnum}[] = [];
  titleCheckbox: boolean = false;
  termsConfirmed: boolean = false;
  submitted: boolean = false;
  private unsubscribe: Subject<void> = new Subject();

  @Input() openedSidebar: boolean;
  constructor(
    private store: Store<any>,
    public faService: FontAwesomeService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.store.select(selectRouterUrl)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((url => {
        this.title = null;
        this.buttons = [];
        this.titleCheckbox = null;
        this.submitted = false;
        switch (url) {
          case '/create-consignment':
            this.title = this.translate.instant('account.section.createConsignment.actions.info');
            this.buttons = [
              {
                action: this.footerActions.SAVE_SHIPMENT
              },
              {
                type: this.footerActions.GO_FORWARD,
                action: this.footerActions.GO_TO_CREATE_CONSIGNMENT_SEARCH_RESULT
              },
            ];
            break;
          case '/create-consignment/search-result':
            this.title = this.translate.instant('account.section.createConsignment.actions.infoSearchResult');
            this.buttons = [
              /*
              {
                type: this.footerActions.GO_BACKWARD,
                action: this.footerActions.GO_TO_CREATE_CONSIGNMENT
              },
              */
              {
                type: this.footerActions.GO_FORWARD,
                action: this.footerActions.GO_TO_CREATE_CONSIGNMENT_ORDER_SUMMARY
              }
            ];
            break;
          case '/create-consignment/order-summary':
            this.title = 'I confirm that I have read and accept Freightseekers general Terms & Conditions...';
            this.titleCheckbox = true;
            this.buttons = [
              {
                type: this.footerActions.GO_BACKWARD,
                action: this.footerActions.GO_TO_CREATE_CONSIGNMENT_SEARCH_RESULT
              },
              { action: this.footerActions.GO_TO_CREATE_CONSIGNMENT_ORDER_COMPLETE }
            ];
            break;
          case '/create-consignment/order-complete':
            this.title = null;
            this.buttons = [
              // { action: this.footerActions.PRINT_ORDER_LABELS },
              // { action: this.footerActions.PRINT_ORDER_WAYBILL },
              // { action: this.footerActions.PRINT_ORDER_RECEIPT_LIST },
              // { action: this.footerActions.PRINT_ORDER_PICKING_LIST },
              // { action: this.footerActions.PRINT_ORDER_RECEIPT },
              // { action: this.footerActions.GO_TO_BOOKED_SHIPMENTS },
            ];
            break;
          case '/settings':
            this.title = null;
            this.buttons = [
              { action:  this.footerActions.SAVE_SETTINGS }
            ];
            break;
          case '/address-book/new':
          case String(url.match(/^\/address-book\/edit.*/)):
            this.title = null;
            this.buttons = [
              { action: this.footerActions.SAVE_ADDRESS }
            ];
            break;
          case '/address-book':
            this.title = null;
            this.buttons = [
              { action: this.footerActions.DELETE_SELECTED_ADDRESSES },
            ];
            break;
            case '/shipments/booked':
            this.title = this.translate.instant('account.section.shipment.booked.action.info');
            this.buttons = [
              { action: this.footerActions.PRINT_LABELS_FOR_SELECTED_SHIPMENTS },
              { action: this.footerActions.PRINT_WAYBILL_FOR_SELECTED_SHIPMENTS },
              { action: this.footerActions.PRINT_RECEIPT_LIST_FOR_SELECTED_SHIPMENTS },
              // { action: this.footerActions.PRINT_PICKING_LIST_FOR_SELECTED_SHIPMENTS },
            ];
            break;
          case '/shipments/saved':
            this.title = this.translate.instant('account.section.shipment.saved.action.info');
            this.buttons = [
              { action: this.footerActions.DELETE_SELECTED_SHIPMENTS },
              { action: this.footerActions.GO_TO_CREATE_CONSIGNMENT_SEARCH_RESULT }
            ];
            break;
          default:
            break;
        }
      }));
    this.store.select(selectShipmentProductTerms)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => this.carriers = data);
  }

  createAction(action) {
    this.store.dispatch({
      type: FOOTER_ACTION_SET,
      payload: {
        action
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.ts